var _excluded = ["name", "value", "maxValue", "step", "onChange", "onMouseUp", "onInput", "onKeyDown", "hideThumb", "noInteraction"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Input } from './Slider.styles';
var Slider = function Slider(_ref) {
  var name = _ref.name,
    value = _ref.value,
    maxValue = _ref.maxValue,
    step = _ref.step,
    _onChange = _ref.onChange,
    _onMouseUp = _ref.onMouseUp,
    _onInput = _ref.onInput,
    onKeyDown = _ref.onKeyDown,
    hideThumb = _ref.hideThumb,
    noInteraction = _ref.noInteraction,
    props = _objectWithoutProperties(_ref, _excluded);
  var inputRef = useRef(null);
  var handleKeyDown = function handleKeyDown(event) {
    var code = event.code;
    if (code === 'Space') {
      // Blur player sliders when user plays track
      event.target.blur();
    }
    onKeyDown && onKeyDown(event);
  };
  var handleClick = function handleClick(event) {
    /**
     * Blur on click event to maintain player keyboard controls
     */
    event.target.blur();
  };
  useEffect(function () {
    inputRef.current.style.backgroundSize = "".concat(value * 100 / maxValue, "% 100%");
  }, [value]);
  return /*#__PURE__*/React.createElement(Input, _extends({
    "aria-label": name,
    type: "range",
    role: "slider",
    value: value,
    "aria-valuenow": value,
    min: "0",
    "aria-valuemin": "0",
    max: maxValue,
    "aria-valuemax": maxValue,
    step: step
    // TODO: Better to just pass event (makes these events more usable)
    ,
    onMouseUp: function onMouseUp(e) {
      return _onMouseUp(e.target.value);
    },
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    },
    onInput: function onInput(e) {
      return _onInput(e.target.value);
    },
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    ref: inputRef,
    "aria-orientation": "horizontal",
    hideThumb: hideThumb,
    noInteraction: noInteraction
  }, props));
};
Slider.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  maxValue: PropTypes.string,
  step: PropTypes.number,
  onMouseUp: PropTypes.func,
  onChange: PropTypes.func,
  onInput: PropTypes.func,
  onKeyDown: PropTypes.func,
  hideThumb: PropTypes.bool,
  noInteraction: PropTypes.bool
};
Slider.defaultProps = {
  // Defaults reflect volume slider
  maxValue: '1',
  step: 0.1,
  onMouseUp: function onMouseUp() {},
  onChange: function onChange() {},
  onInput: function onInput() {},
  onKeyDown: function onKeyDown() {},
  hideThumb: false,
  noInteraction: false
};
export default Slider;